import { gql } from '@apollo/client'

import { getMutationService } from '../../../../helpers/GraphqlHelpers'
import { UserFragment } from '../../../fragments'
import { User } from '../../../generated/graphql'

export const acceptCgu = getMutationService({
  mutation: gql`
    mutation acceptCgu {
      acceptCgu {
        ...UserFragment
      }
    }
    ${UserFragment}
  `,
  transformer: (response): User => {
    return response.acceptCgu
  },
})
